<div id="equal-opportunity-cell" class="inner-page py-5">
  <div class="container px-lg-5">

    <!-- Header Section -->
    <div class="text-center mb-5">
      <h1 class="display-6 fw-bold text-uppercase text-orange mb-2" style="color: #f48020;">Equal Opportunity Cell</h1>
      <h4 class="fw-semibold text-dark mb-4">"Nurturing Diversity, Promoting Social Equity and Harmony"</h4>
      <p class="lead text-muted mx-auto" style="max-width: 900px; line-height: 1.8; text-align: justify;">
        The Equal Opportunity Cell (EOC) at Shah Satnam Ji Girls College is committed to creating an inclusive, diverse, and equitable academic environment. We work to eliminate all forms of discrimination and ensure equal growth opportunities for students from all walks of life.
      </p>
      <hr class="divider mx-auto" style="width: 80px; height: 3px; background: var(--primary); border: none; opacity: 1;">
    </div>

    <!-- Content Card -->
    <div class="content-card p-4 p-md-5 shadow-sm rounded-4 bg-white border-top border-5 border-success mb-5">
      
      <!-- Key Objectives -->
      <h5 class="fw-bold text-success text-uppercase mb-3" style="letter-spacing: 0.5px;">Our Core Aims & Objectives</h5>
      <p class="text-muted mb-3">The Cell coordinates academic, financial, and administrative support to promote social justice:</p>
      <ul class="text-muted mb-4" style="line-height: 1.8; padding-left: 20px;">
        <li class="mb-2"><strong>Zero Discrimination Policy:</strong> Ensuring strict prohibition of discrimination based on caste, creed, religion, social status, or gender.</li>
        <li class="mb-2"><strong>Access to Welfare Schemes:</strong> Spreading awareness about and facilitating applications for government fellowships, scholarships, and free hostel accommodations.</li>
        <li class="mb-2"><strong>Capacity Building Workshops:</strong> Conducting language, soft skills, and personality development workshops for marginalized groups to boost employability.</li>
        <li class="mb-2"><strong>Mentorship and Guidance:</strong> Dedicated counseling sessions to help students resolve academic, emotional, and social concerns.</li>
      </ul>

      <!-- Inclusive Events -->
      <h5 class="fw-bold text-success text-uppercase mb-3" style="letter-spacing: 0.5px;">Annual Awareness & Empowerment Activities</h5>
      <p class="text-muted mb-3">We regularly host programs that foster empathy, mutual respect, and social harmony across the campus:</p>
      <ul class="text-muted mb-4" style="line-height: 1.8; padding-left: 20px;">
        <li class="mb-2"><strong>Constitutional Awareness Lectures:</strong> Seminars on Fundamental Rights, Directive Principles, and social reservation policies.</li>
        <li class="mb-2"><strong>Gender Sensitization Drives:</strong> Interactive group discussions to build gender equality and safety awareness.</li>
        <li class="mb-2"><strong>Cultural Exchange Events:</strong> Celebrating national festivals and diverse regional cultures to build cross-cultural understanding.</li>
      </ul>

      <!-- A Safe & Supportive Space -->
      <h5 class="fw-bold text-success text-uppercase mb-3" style="letter-spacing: 0.5px;">A Safe and Supportive Space</h5>
      <p class="text-muted mb-3" style="text-align: justify; line-height: 1.8;">
        The Equal Opportunity Cell acts as a safe haven where students can freely discuss grievances related to social bias or unfair treatment. Under the direction of our senior advisory board, we ensure rapid redressal of any concerns, ensuring absolute peace and mutual respect on campus.
      </p>

      <!-- Alert Banner -->
      <div class="p-4 rounded-4 mt-5 text-center" style="background-color: #fcece3; border: 1px solid #ffd8c3;">
        <h5 class="fw-bold mb-2" style="color: #e06c00;">"Strength lies in differences, not in similarities."</h5>
        <p class="mb-0 fw-semibold text-muted" style="font-size: 15px;">Join our workshops, represent our cell, and help us build a more harmonious college community.</p>
      </div>

    </div>

  </div>
</div>
